import type { Priority, ProjectStatus } from '@cw/shared';
import type { Tone } from '@/design-system/components/badge';

export const STATUS_TONE: Record<ProjectStatus, Tone> = {
  planning: 'lavender',
  active: 'info',
  adjusting: 'warning',
  awaiting_approval: 'coral',
  on_hold: 'warning',
  completed: 'success',
  cancelled: 'neutral',
};
export const PRIORITY_TONE: Record<Priority, Tone> = {
  urgent: 'danger',
  high: 'coral',
  medium: 'neutral',
  low: 'neutral',
};
/** Colunas do Kanban de projetos: as mesmas etapas do quadro do cliente. Pausado é selo, não coluna. */
export const STATUS_ORDER: ProjectStatus[] = [
  'planning',
  'active',
  'adjusting',
  'awaiting_approval',
  'completed',
];
